<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17FOKFC/images/9781439674635.jpg?1684306039847" alt="This image is the cover for the book Princeton University, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Princeton University, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Princeton is only the fourth American college to celebrate a 275th anniversary.</b></p><p> Founded in 1746 as the College of New Jersey, it has long Presbyterian roots. The scene of notable events in the American Revolution, it was a classical college for another century. Then, at its 1896 sesquicentennial, it became Princeton University and in succeeding decades developed into a world-leading research university. Long an institution of males of European descent, its gender and ethnic makeup has changed dramatically in the last half-century. Today's Princeton combines a robust collegiate culture with a research profile near the top of international league tables--truly a rare combination.</p><p>Author W. Bruce Leslie is a New Jersey native and a 1966 alumnus of Princeton University. As the grandson of a Scottish immigrant, studying at an institution with deep Scottish roots was a natural path. The author fell in love with liberal education thanks to Princeton's wonderful faculty and fellow students. Inspired by them, he taught history for a half-century at the State University of New York at Brockport, seeking to bestow a similar affection for learning, especially about the past, on his students. Returning to his roots in retirement, he is rediscovering the richness of this cultural and intellectual community.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W. Bruce Leslie
      </h2>
      
      <p class="authorDescription body article">Author W. Bruce Leslie is a New Jersey native and a 1966 alumnus of Princeton University. As the grandson of a Scottish immigrant, studying at an institution with deep Scottish roots was a natural path. The author fell in love with liberal education thanks to Princeton's wonderful faculty and fellow students. Inspired by them, he taught history for a half-century at the State University of New York at Brockport, seeking to bestow a similar affection for learning, especially about the past, on his students. Returning to his roots in retirement, he is rediscovering the richness of this cultural and intellectual community.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e27bd786